module.exports = __webpack_public_path__ + "img/usaMap@2x.e4ed173d.gif";